import { toast } from 'react-hot-toast'
import PassengerBusService from '@services/passenger-bus'

// Action Types
export const GET_DRIVER_CERTIFICATIONS = 'GET_DRIVER_CERTIFICATIONS'
export const GET_DRIVER_CERTIFICATION = 'GET_DRIVER_CERTIFICATION'
export const ADD_DRIVER_CERTIFICATION = 'ADD_DRIVER_CERTIFICATION'
export const UPDATE_DRIVER_CERTIFICATION = 'UPDATE_DRIVER_CERTIFICATION'
export const DELETE_DRIVER_CERTIFICATION = 'DELETE_DRIVER_CERTIFICATION'
export const GET_CONDUCTOR_CERTIFICATIONS = 'GET_CONDUCTOR_CERTIFICATIONS'
export const GET_CONDUCTOR_CERTIFICATION = 'GET_CONDUCTOR_CERTIFICATION'
export const ADD_CONDUCTOR_CERTIFICATION = 'ADD_CONDUCTOR_CERTIFICATION'
export const UPDATE_CONDUCTOR_CERTIFICATION = 'UPDATE_CONDUCTOR_CERTIFICATION'
export const DELETE_CONDUCTOR_CERTIFICATION = 'DELETE_CONDUCTOR_CERTIFICATION'
export const SET_LOADING = 'SET_CERTIFICATION_LOADING'
export const SET_ERROR = 'SET_CERTIFICATION_ERROR'

// ** Get All Driver Certifications
export const getDriverCertifications = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getDriverCertifications()
      dispatch({
        type: GET_DRIVER_CERTIFICATIONS,
        payload: data
      })
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to fetch driver certifications')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Get Driver Certification by CID
export const getDriverCertificationsByCid = (cid) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getDriverCertificationsByCid(cid)
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to fetch driver certifications')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Get Driver Certification by License Number
export const getDriverCertificationByLicenseNo = (licenseNo) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getDriverCertificationByLicenseNo(licenseNo)
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Driver certification not found')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Get Single Driver Certification
export const getDriverCertification = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getDriverCertification(id)
      dispatch({
        type: GET_DRIVER_CERTIFICATION,
        payload: data
      })
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to fetch driver certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Add Driver Certification
export const addDriverCertification = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const result = await PassengerBusService.addDriverCertification(data)
      dispatch({
        type: ADD_DRIVER_CERTIFICATION,
        payload: result
      })
      toast.success('Driver certification added successfully')
      return result
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error(error.response?.data?.message || 'Failed to add driver certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Update Driver Certification
export const updateDriverCertification = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const result = await PassengerBusService.updateDriverCertification({ id, ...data })
      dispatch({
        type: UPDATE_DRIVER_CERTIFICATION,
        payload: result
      })
      toast.success('Driver certification updated successfully')
      return result
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to update driver certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Delete Driver Certification
export const deleteDriverCertification = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      await PassengerBusService.deleteDriverCertification(id)
      dispatch({
        type: DELETE_DRIVER_CERTIFICATION,
        payload: id
      })
      toast.success('Driver certification deleted successfully')
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to delete driver certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Get All Conductor Certifications
export const getConductorCertifications = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getConductorCertifications()
      dispatch({
        type: GET_CONDUCTOR_CERTIFICATIONS,
        payload: data
      })
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to fetch conductor certifications')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Get Conductor Certifications by CID
export const getConductorCertificationsByCid = (cid) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getConductorCertificationsByCid(cid)
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to fetch conductor certifications')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Get Single Conductor Certification
export const getConductorCertification = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const data = await PassengerBusService.getConductorCertification(id)
      dispatch({
        type: GET_CONDUCTOR_CERTIFICATION,
        payload: data
      })
      return data
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to fetch conductor certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Add Conductor Certification
export const addConductorCertification = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const result = await PassengerBusService.addConductorCertification(data)
      dispatch({
        type: ADD_CONDUCTOR_CERTIFICATION,
        payload: result
      })
      toast.success('Conductor certification added successfully')
      return result
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error(error.response?.data?.message || 'Failed to add conductor certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Update Conductor Certification
export const updateConductorCertification = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      const result = await PassengerBusService.updateConductorCertification({ id, ...data })
      dispatch({
        type: UPDATE_CONDUCTOR_CERTIFICATION,
        payload: result
      })
      toast.success('Conductor certification updated successfully')
      return result
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to update conductor certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}

// ** Delete Conductor Certification
export const deleteConductorCertification = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true })
    try {
      await PassengerBusService.deleteConductorCertification(id)
      dispatch({
        type: DELETE_CONDUCTOR_CERTIFICATION,
        payload: id
      })
      toast.success('Conductor certification deleted successfully')
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error.message })
      toast.error('Failed to delete conductor certification')
      throw error
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
}
